import { Popover } from "./v2/Popover";
import { SortDownSolidV6 } from "./v2/Icomoon";

const SelectAll = ({ selectAll, selectAllHandler, selectNone, selectNoneHandler }) => (
  <Popover placment="bottom-end">
    <Popover.Trigger>
      <button className="tw-border-none tw-bg-transparent tw-mt-[10px] tw-mb-[3px] tw-text-11d tw-flex tw-items-start tw-gap-[4px]">
        Select
        <SortDownSolidV6 />
      </button>
    </Popover.Trigger>
    <Popover.Content>
      <Popover.Item onClick={selectAllHandler} checkboxProps={{ checked: selectAll }}>
        All on Page
      </Popover.Item>
      <Popover.Item onClick={selectNoneHandler} checkboxProps={{ checked: selectNone }}>
        None
      </Popover.Item>
    </Popover.Content>
  </Popover>
);

export default SelectAll;
